/* [BD] FAQ — bd-faq + bd_FAQ_pdp accordion (loaded only with those sections) */
;(function () {
  function initBdFaq(root) {
    if (!root) return;

    var questions = root.querySelectorAll('.bd_faq_pdp__question, .bd_main_faq__question');
    if (!questions.length) return;

    questions.forEach(function (btn) {
      if (btn.getAttribute('data-bd-faq-init') === '1') return;
      btn.setAttribute('data-bd-faq-init', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.bd_faq_pdp__item, .bd_main_faq__item');
        if (!item) return;
        var wasOpen = item.classList.contains('active');
        var items = root.querySelectorAll('.bd_faq_pdp__item, .bd_main_faq__item');

        items.forEach(function (faqItem) {
          faqItem.classList.remove('active');
          var trigger = faqItem.querySelector('.bd_faq_pdp__question, .bd_main_faq__question');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          item.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function boot(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.bd_faq_pdp, .bd_main_faq').forEach(initBdFaq);
    if (
      root.matches &&
      (root.matches('.bd_faq_pdp') || root.matches('.bd_main_faq'))
    ) {
      initBdFaq(root);
    }
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode && !window.__bdSectionFaqDesignMode) {
    window.__bdSectionFaqDesignMode = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (!e.target) return;
      boot(e.target);
    });
  }
})();
